import axios from "../API/API";
import { FILE_SERVICE_BASE_URL } from "../constant/apiUrl";
import { showErrorToast } from "./Toast/toast";

const fetchAndCacheImage = async (
  contentId,
  action,
  dispatch,
  isFileId = true
) => {
  try {
    // Step 1: Get the total number of parts
    const rangeResponse = await axios.get(
      `${FILE_SERVICE_BASE_URL}/fritolay/file-manager/download/blob-range-info/${contentId}?isFileId=${isFileId}`
    );

    const totalParts = rangeResponse.data;
    if (!totalParts || totalParts <= 0) {
      throw new Error("No parts available to download.");
    }

    // Step 2: Download parts in parallel
    const downloadPromises = Array.from({ length: totalParts }, (_, index) =>
      axios.get(
        `${FILE_SERVICE_BASE_URL}/fritolay/file-manager/download/blob-range/${contentId}/${index}?isFileId=${isFileId}`,
        {
          headers: { "Content-Type": "application/octet-stream" },
          responseType: "arraybuffer",
        }
      )
    );

    const responses = await Promise.all(downloadPromises);

    const fileName = responses[0].headers["file-name"] || "file";
    const fileExtension = fileName.split(".").pop() || "bin";
    const mimeType = getMimeType(fileExtension);

    // Step 3: Combine parts into one Blob
    const combinedBlob = new Blob(
      responses.map((res) => res.data),
      {
        type: mimeType,
      }
    );

    // Step 4: Create a URL for the blob
    const url = URL.createObjectURL(combinedBlob);

    if (action) {
      dispatch(action({ contentId, url }));
    }

    return url;
  } catch (error) {
    console.error("Error downloading file:", error);
    showErrorToast("Failed to download file");
    return null;
  }
};

// Optional helper for better MIME type handling
function getMimeType(ext) {
  const map = {
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    gif: "image/gif",
    pdf: "application/pdf",
    txt: "text/plain",
    mp4: "video/mp4",
    webm: "video/webm",
    mp3: "audio/mpeg",
    json: "application/json",
  };
  return map[ext.toLowerCase()];
}

export default fetchAndCacheImage;
